import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { SortEvent } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { GlobalConstants } from '../../global-constants';

@Component({
  selector: 'app-lms-table',
  templateUrl: './lms-table.component.html',
  styleUrls: ['./lms-table.component.scss'],
})
export class LmsTableComponent implements OnInit {
  singleRowCheckbox: any[] = [];
  lmsTableData;
  public dropDownList = ['ABC', 'ABCD', 'ABCEFG', 'ABCHIJK'];
  public activeRowIndex: any;
  public actionData: any;
  public showActionPanel: boolean;
  public allChecked = false;
  public firstItemIndex = 0;
  public selected = false;
  totalRecords = 0;
  tableCss;
  f = 0;
  l = 25;
  lastSortField: string;

  @ViewChildren('tableCheckBox') public tableCheckBox: QueryList<any>;
  @Input() columnData: [];
  @Input() set tableData(data: any) {
    this.allChecked = false;
    this.lmsTableData = data;
    this.totalRecords = data ? data.length : 0;
  }
  get tableData(): any {
    return this.lmsTableData;
  }
  @Input() paginator: boolean;
  @Input() rowsPerPage: number;
  @Input() scrollable: boolean;
  @Input() scrollHeight: string;
  @Input() modalData: {};
  @Input() rowsPerPageOptions: [];
  @Input() showCurrentPageReport: boolean;
  @Input() searchFields;
  @Input() enableSearch: boolean;
  @Input() searchPlaceHolder: string;
  @Input() first = 0;
  @Input() disableSwitch = false;
  @Input() disableDropdown = false;
  @Input() disableCheckbox = false;
  @Input() enableSort = false;
  @Input() customSortField: string;
  @Input() defaultSortField: string;
  @Input() defaultSortOrder: number;
  @Input() sortByDeviceHealth: any;
  @Input() sortByDeviceConnectivity: any;
  @Input() deviceHealthSortField: string;
  @Input() deviceConnectivitySortField: string;
  @Input() dataKey: string;

  @Output() shareOnTextClickData = new EventEmitter();
  @Output() shareOnclickData = new EventEmitter();
  @Output() shareOnLinkNumberData = new EventEmitter();
  @Output() shareDataOnIconCLick = new EventEmitter();
  @Output() shareDataOnActionClick = new EventEmitter();
  @Output() selectedCheckBoxes = new EventEmitter();
  @Output() singleCheckBoxSelection = new EventEmitter();
  @Output() selectBoxSelection = new EventEmitter();
  @Output() shareOnSwitchStatusChange = new EventEmitter();
  @Output() pageChange = new EventEmitter();
  @Output() shareOnDonwloadClick = new EventEmitter();


  constructor(public dialogService: DialogService) { }

  ngOnInit(): void {
    this.customSortField = "lastViewed";
    if (localStorage.getItem("saveSortingForFilter") == "1") {
      this.defaultSortField = localStorage.getItem("lastSort");
      this.defaultSortOrder = parseInt(localStorage.getItem("lastOrder"));
    } else {
      this.defaultSortField = "lastViewed";
      this.defaultSortOrder = -1;
    }
  }

  clearAllCheckBoxes(): void {
    const arrCB = this.tableCheckBox.toArray();
    for (const key in arrCB) {
      if (arrCB.hasOwnProperty(key)) {
        arrCB[key].checked = false;
      }
    }
    this.allChecked = false;
    this.selected = false;
  }

  /** calls on hyperlink in table */
  onLinkClick(Data: any): void {
    this.shareOnclickData.emit(Data);
  }

  onLinkNumberClick(Data: any): void {
    this.shareOnLinkNumberData.emit(Data);
  }

  /** calls on click of any icon except ellipsis icon.  Emits row data of clicked icon */
  onIconClick(rowData): void {
    this.shareDataOnIconCLick.emit(rowData);
  }

  onTextClick(rowData): void {
    this.shareOnTextClickData.emit(rowData);
  }

  /** calls on ellipsis icon click and emits selection of modal value */
  actionClick(Data, event): void {
    this.actionData = {
      data: Data,
      actionName: event,
    };
    this.shareDataOnActionClick.emit(this.actionData);
  }

  // checkbox on table header to select/ de-select all rows and emit selcted rows id/value
  headerCheckBoxEvent(e): void {
    this.selected = false;
    const arrCB = this.tableCheckBox.toArray();
    if (e.checked) {
      for (const key in arrCB) {
        if (arrCB.hasOwnProperty(key)) {
          arrCB[key].checked = true;
        }
      }
    } else {
      for (const key in arrCB) {
        if (arrCB.hasOwnProperty(key)) {
          arrCB[key].checked = false;
        }
      }
    }
    this.getSelectedCheckBoxesData();
  }

  getSelectedCheckBoxesData(): void {
    const arr = [];
    const arrCB = this.tableCheckBox.toArray();
    for (let key = 0; key < arrCB.length; key++) {
      if (arrCB.hasOwnProperty(key)) {
        if (arrCB[key].checked) {
          arr.push(this.tableData[this.firstItemIndex + key]);
        }
      }
    }
    if (arrCB.length !== arr.length) {
      this.allChecked = false;
    } else {
      this.allChecked = true;
    }
    if (arr.length === 0) {
      this.selected = false;
      this.allChecked = false;
    }
    this.selectedCheckBoxes.emit(arr);
  }

  // handle single row check box selection and emit row value
  rowCheckBoxEvent(e, rowData): void {
    this.selected = true;
    this.getSelectedCheckBoxesData();
  }

  // change state
  changeState(e, data): void {
    this.selectBoxSelection.emit({ e, data });
  }

  // change switch status
  switchStatusChange(data): void {
    this.shareOnSwitchStatusChange.emit(data);
  }

  downloadClick(data): void {
    this.shareOnDonwloadClick.emit(data);
  }
  //
  call(e): any {
    return e;
  }

  pageChanged(event): void {
    this.f = event.first;
    this.l = event.rows;
    this.firstItemIndex = event.first;
    this.first = event.first === 0 ? event.first : this.first; // Added code to resolved LMS-1057
    this.pageChange.emit(event);
  }

  customSort(event: SortEvent): void {
    localStorage.setItem("lastSort", event.field);
    localStorage.setItem("lastOrder", event.order.toString());
    this.defaultSortField = localStorage.getItem("lastSort");

    this.lastSortField = event.field;
    event.data.sort((data1, data2) => {
      const value1 = data1[event.field];
      const value2 = data2[event.field];
      let result = null;
      if (value1 === null && value2 !== null) { result = -1; }
      else if (value1 !== null && value2 === null) { result = 1; }
      else if (value1 === null && value2 === null) { result = 0; }
      else if (event.field.includes(this.customSortField)) {
        const v1 = new Date(value1);
        const v2 = new Date(value2);
        result = v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
      } else if (event.field.includes(this.deviceHealthSortField)) {
        const fld = this.deviceHealthSortField;
        result =
          this.sortByDeviceHealth[data2[fld]] -
          this.sortByDeviceHealth[data1[fld]];
      } else if (event.field.includes(this.deviceConnectivitySortField)) {
        const fld = this.deviceConnectivitySortField;
        result =
          this.sortByDeviceConnectivity[data2[fld]] -
          this.sortByDeviceConnectivity[data1[fld]];
      } else if (typeof value1 === 'string' && typeof value2 === 'string') {
        result = value1.localeCompare(value2);
      }
      else { result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0; }
      return event.order * result;
    });
  }

  applyConnectionStatusStyle(connectionStatus): object {
    let applyStyle = {};

    switch (connectionStatus) {
      case GlobalConstants.connected: {
        applyStyle = { color: '#00D621' };
        break;
      }
      case GlobalConstants.lost: {
        applyStyle = { color: '#e4e4e3' };
        break;
      }
      case GlobalConstants.offline: {
        applyStyle = { color: 'red' };
        break;
      }
      default: {
        applyStyle = { color: '#535353' };
        break;
      }
    }
    return applyStyle;
  }
}
